export default __webpack_public_path__ + "static/media/space-blue.fa8cd310.jpeg";